import React, { useState, useEffect } from 'react';
import { get, clone, flatten, cloneDeep, last } from 'lodash';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';
import CModal from '_Components/CModal/CModal';
import { QSideBarLayout } from '_Components/Layouts/QSideBarLayout';
import QButton from '_Components/Buttons/QButton/QButton';
// import QBooleanSwitch from '_Components/Fields/QBooleanSwitch/QBooleanSwitch';
import {
  StyledDropdown,
  StyledDropdownToggle,
  Item,
  ToggleButton,
  Menu,
  Label,
} from '_Cards/FilterCards/DataByFiltersCard/_Containers/Dropdowns/utils/DropdownStyles';
import { ImageSize } from 'styles/abstracts/variables';
import Icon from '_Components/Icons/Icon';
import { setHorizontalLevelToDisplay } from '_Resources/Benchmark/Actions/setHorizontalLevelToDisplay';
import { setAspectToDisplay } from '_Resources/Benchmark/Actions/setAspectToDisplay';
import { setUnitToDisplay } from '_Resources/Benchmark/Actions/setUnitToDisplay';
import { setOnlySelectedCategories } from '_Resources/Benchmark/Actions/setOnlySelectedCategories';
import { ORDER_BY_ITEMS } from '_Cards/ThematicsCard/ThematicsOverviewCards/ThematicsHorizontalChartCard/utils';
import { setHorizontalCategoriesOrder } from '_Resources/Benchmark/Actions/setHorizontalCategoriesOrder';
import ThematicSelectionDropdown from '_Cards/ThematicsCard/ThematicsOverviewCards/CategoryBreakdownCard/_Containers/DropdownsContainer/_Components/ThematicSelectionDropdown';
import { selectThematicSelection } from '_Resources/Cards/Actions/selectThematicSelection';
import { useQuery, useMutation } from 'react-apollo';
import GET_THEMATICS_OVERVIEW_DATA_QUERY from '_Cards/ThematicsCard/ThematicsOverviewCards/graphql/getThematicsOverviewData';
import {
  getSelectedThematicsForSettings,
  getDefaultSettings,
} from '_Cards/ThematicsCard/ThematicsOverviewCards/CategoryBreakdownCard/utils';
import SAVE_THEMATICS_OVERVIEW_SETTINGS from '_Cards/ThematicsCard/ThematicsOverviewCards/graphql/saveThematicsOverviewSettings';
import GET_THEMATIC_SELECTION_LIST from '_Cards/ThematicsCard/ThematicsOverviewCards/graphql/getThematicSelectionList.js';
import { setThematicSelectionList } from '_Resources/Cards/Actions/setThematicSelectionList';
import { setHorizontalSelectedThematicSelectionOption } from '_Resources/Benchmark/Actions/setHorizontalSelectedThematicSelectionOption';
import { grayShades } from '../../../../../styles/abstracts/colors';
import BenchmarkHorizontalGraphOrderByDropdown from './BenchmarkHorizontalGraphOrderByDropdown';

const StyledCModal = styled(CModal)`
  max-width: 500px !important;
`;

const HeaderArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Body = styled.div`
  margin: -16px;
`;

const QSideBarLayoutDisplayArea = styled.div`
  flex-grow: 1;
  /* overflow: hidden; */
`;

const StyledQButton = styled(QButton)`
  display: flex;
  align-items: center;
  border-radius: 50%;
  justify-content: center;
  position: absolute;
  right: 1em;
  top: 1em;
  padding: 0 !important;
`;

const SettingDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 2em;
  font-weight: bold;
`;

const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledToggleButton = styled(ToggleButton)`
  width: 13rem;
`;

const LabelContainer = styled.div`
  display: flex;
`;

const StyledSpan = styled.span`
  margin-left: 1em;

  &:hover > div {
  visibility: visible;
`;
const TooltipThematic = styled.div`
  visibility: hidden;
  max-width: 20em;
  position: absolute;
  top: 0px;
  z-index: 30;
  background-color: ${grayShades.g200};
  text-align: center;
  padding: 5px 4px;
  border-radius: 8px;
  color: ${grayShades.g800};
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.5);
  width: max-content;
  font-size: 12px;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 12px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: ${grayShades.g200} transparent transparent transparent;
  }
`;

type BenchmarkHorizontalGraphSettingsModalProps = {
  onClose: any;
  isOpen: boolean;
  t: any;
  dispatchSetHorizontalLevelToDisplay: any;
  dispatchSetAspectToDisplay: any;
  dispatchSetUnitToDisplay: any;
  dispatchSetOnlySelectedCategories: any;
  benchmarkHorizontalLevelToDisplay: string;
  benchmarkAspectToDisplay: string;
  benchmarkUnitToDisplay: string;
  benchmarkOnlySelectedCategories: boolean;
  benchmarkHorizontalCategoriesOrder: { id: string; label: string };
  dispatchSetHorizontalCategoriesOrder: Function;
  dispatchSetHorizontalSelectedThematicSelectionOption: Function;
  dispatchSelectThematicSelection: Function;
  dispatchSetThematicSelectionList: Function;
  projectId: number;
  filterKeys: any;
  selectionList: any[];
  horizontalSelectedThematicSelectionOption: any;
  selectedThematicSelectionOption: any;
  range: {
    startDate: Date;
    endDate: Date;
  };
  dataCollectorId: number;
  horizontalSelectedThematicSelectionId: number;
  thematicSelectionId: number;
};

const BenchmarkHorizontalGraphSettingsModal = ({
  onClose,
  isOpen,
  t,
  dispatchSetHorizontalLevelToDisplay,
  dispatchSetAspectToDisplay,
  dispatchSetUnitToDisplay,
  dispatchSetOnlySelectedCategories,
  benchmarkHorizontalLevelToDisplay,
  benchmarkAspectToDisplay,
  benchmarkUnitToDisplay,
  benchmarkOnlySelectedCategories,
  benchmarkHorizontalCategoriesOrder,
  dispatchSetHorizontalCategoriesOrder,
  dispatchSetHorizontalSelectedThematicSelectionOption,
  dispatchSelectThematicSelection,
  dispatchSetThematicSelectionList,
  projectId,
  filterKeys,
  selectionList,
  horizontalSelectedThematicSelectionOption,
  selectedThematicSelectionOption,
  range,
  dataCollectorId,
  horizontalSelectedThematicSelectionId,
  thematicSelectionId,
}: BenchmarkHorizontalGraphSettingsModalProps) => {
  const [onlySelectedCategories, setLocalOnlySelectedCategories] = useState(benchmarkOnlySelectedCategories || false);

  const [isLevelDropdownOpen, openLevelDropdown] = useState<boolean>(false);
  const [isAspectDropdownOpen, openAspectDropdown] = useState<boolean>(false);
  const [isUnitDropdownOpen, openUnitDropdown] = useState<boolean>(false);

  const [settings, setSettings] = useState({});
  const [queryFilters, setQueryFilters] = useState(filterKeys);

  useEffect(() => {
    const filters = cloneDeep(filterKeys);
    filters.keywords = flatten(filterKeys.texts?.filter(t => t.name === 'keywords').map(t => t.values)) || [];
    delete filters.texts;
    setQueryFilters(filters);
  }, [filterKeys]);

  const { data: thematicsOverviewData, loading, refetch } = useQuery(GET_THEMATICS_OVERVIEW_DATA_QUERY, {
    variables: { ...queryFilters, projectId, range, dataCollectorId, horizontalSelectedThematicSelectionId },
  });

  let formattedData: any[] = [];

  const formatDeep = (arrayToIterate, level, objToFill) => {
    let newObjToFill = {};
    arrayToIterate?.map(item => {
      const childrenKey = Object.keys(item).find(i => Array.isArray(item[i]));
      newObjToFill = {
        ...objToFill,
        [level]: item.thematicsOverviewDetails.name,
      };
      formattedData = [...formattedData, newObjToFill];
      if (Array.isArray(item[childrenKey])) {
        formatDeep(
          item[childrenKey],
          childrenKey?.toLowerCase()?.substring(0, childrenKey.length - 1),
          newObjToFill,
          formattedData,
        );
      }
    });
    return formattedData;
  };

  const categoriesHierarchies = formatDeep(
    thematicsOverviewData?.getThematicsOverviewData?.thematics,
    'thematic',
    {},
  ).map(item => {
    if (!item.subthematic) {
      return { ...item, subthematic: null, subsubthematic: null };
    }
    if (!item.subsubthematic) {
      return { ...item, subsubthematic: null };
    }
    return item;
  });

  const defaultSettings = getDefaultSettings(categoriesHierarchies);

  useEffect(() => {
    if (thematicsOverviewData) {
      setSettings(
        JSON.parse(thematicsOverviewData.getThematicsOverviewData.settings)
          ? {
              ...defaultSettings,
              ...JSON.parse(thematicsOverviewData.getThematicsOverviewData.settings),
              selectedThematics:
                JSON.parse(thematicsOverviewData.getThematicsOverviewData.settings).selectedThematics || formattedData,
            }
          : defaultSettings,
      );
    }
  }, [thematicsOverviewData, loading]);

  const buttonRight = (
    <StyledQButton
      bgColor="greyShades.g300"
      type="button"
      onClick={() => onClose()}
      size="small"
      icon="CROSS"
      iconSize={24}
    />
  );

  const levelsToDisplay = [
    {
      id: 'thematics',
      label: 'Categories',
    },
    {
      id: 'subThematics',
      label: 'Subcategories',
    },
    {
      id: 'subSubThematics',
      label: 'Sub sub categories',
    },
  ];

  const availableAspects = [
    {
      id: 'emotions',
      label: 'Emotions',
    },
    {
      id: 'sentiment',
      label: 'Sentiment',
    },
  ];

  const availableUnits = [
    {
      id: 'volume',
      label: 'Volume',
    },
    {
      id: 'percentage',
      label: 'Percentage',
    },
  ];

  const [currentLevel, setCurrentLevel] = useState(
    levelsToDisplay.find(opt => opt.id === benchmarkHorizontalLevelToDisplay) || levelsToDisplay[1],
  );

  const [currentAnalysisAxis, setCurrentAnalysisAxis] = useState(
    availableAspects.find(opt => opt.id === benchmarkAspectToDisplay) || availableAspects[0],
  );

  const [currentUnit, setCurrentUnit] = useState(
    availableUnits.find(opt => opt.id === benchmarkUnitToDisplay) || availableUnits[0],
  );

  const [currentOrder, setCurrentOrder] = useState(
    benchmarkHorizontalCategoriesOrder || ORDER_BY_ITEMS[0].subcategories[0],
  );

  const onValidate = () => {
    dispatchSetHorizontalLevelToDisplay(currentLevel.id);
    dispatchSetAspectToDisplay(currentAnalysisAxis.id);
    dispatchSetUnitToDisplay(currentUnit.id);
    dispatchSetOnlySelectedCategories(onlySelectedCategories);
    dispatchSetHorizontalCategoriesOrder(currentOrder);
  };

  const getFooter = () => {
    return (
      <ModalFooter>
        <QButton onClick={() => onClose()} size="big" bgColor="gray">
          {t('Cancel')}
        </QButton>
        <QButton
          onClick={() => {
            onValidate();
            onClose();
          }}
          size="big"
          bgColor="purple"
        >
          {t('Validate')}
        </QButton>
      </ModalFooter>
    );
  };

  const allThematics = {
    createdBy: {
      firstName: 'system',
      lastName: 'system',
      email: 'support@qemotion.com',
    },
    id: null,
    label: t('button:All thematics'),
    name: t('button:All thematics'),
    projectId,
    thematics: [],
  };

  const { data: dataThematicSelectionList, loading: loadingSelectionList, refetch: refetchSelectionList } = useQuery(
    GET_THEMATIC_SELECTION_LIST,
    {
      variables: { projectId },
    },
  );

  const [saveThematicsOverviewSettings] = useMutation(SAVE_THEMATICS_OVERVIEW_SETTINGS, {
    variables: {
      projectId,
      thematicSelectionId: horizontalSelectedThematicSelectionOption?.id || null,
      settings: JSON.stringify(settings),
    },
    update: () => {},
  });

  useEffect(() => {
    if (dataThematicSelectionList) {
      const optionsList = dataThematicSelectionList.getThematicSelectionList.map(selection => ({
        ...selection,
        label: selection.name,
      }));

      dispatchSetThematicSelectionList(optionsList);

      const foundStoredThematicSelectionId = optionsList
        .map(option => option.id)
        .find(id => id === horizontalSelectedThematicSelectionOption?.id);

      if (!foundStoredThematicSelectionId && horizontalSelectedThematicSelectionOption?.id !== null) {
        dispatchSetHorizontalSelectedThematicSelectionOption(last(optionsList));
        const cloneSettings = clone(settings);
        const thematicsVariableForSettings = getSelectedThematicsForSettings(last(optionsList)?.thematics);
        cloneSettings.selectedThematics = thematicsVariableForSettings || [];
        saveThematicsOverviewSettings({
          variables: {
            projectId,
            settings: JSON.stringify(cloneSettings),
            thematicSelectionId: last(optionsList)?.id || null,
          },
          refetchQueries: [
            {
              query: GET_THEMATICS_OVERVIEW_DATA_QUERY,
              variables: {
                ...filterKeys,
                projectId,
                range,
                dataCollectorId,
                thematicSelectionId: horizontalSelectedThematicSelectionId,
              },
            },
          ],
        });
      }
    }
  }, [dataThematicSelectionList]);

  const onThematicSelectionChange = selectThematicSelectionOption => {
    dispatchSetHorizontalSelectedThematicSelectionOption(selectThematicSelectionOption);
    const cloneSettings = clone(settings);
    cloneSettings.selectedThematics = getSelectedThematicsForSettings(selectThematicSelectionOption.thematics);
    if (selectThematicSelectionOption?.id !== null) {
      cloneSettings.categoryBreakdown.onlySelectedCategories = true;
    }
    if (selectThematicSelectionOption?.id === null) {
      cloneSettings.selectedThematics = [];
      cloneSettings.categoryBreakdown.onlySelectedCategories = false;
    }
    saveThematicsOverviewSettings({
      variables: {
        projectId,
        settings: JSON.stringify(cloneSettings),
        thematicSelectionId: selectThematicSelectionOption?.id || null,
      },
      refetchQueries: [
        {
          query: GET_THEMATICS_OVERVIEW_DATA_QUERY,
          variables: {
            ...filterKeys,
            projectId,
            range,
            dataCollectorId,
            thematicSelectionId: selectThematicSelectionOption?.id || null,
          },
        },
      ],
    });
  };

  return (
    <>
      <StyledCModal
        data={{}}
        title={t('Settings')}
        displayMentionsSubtitle={false}
        displayCardSubtitle={false}
        displayDateSubtitle={false}
        modal={isOpen}
        footer={getFooter()}
        toggle={onClose}
        buttonRight={buttonRight}
        centered
      >
        <Body>
          <HeaderArea />
          <QSideBarLayout>
            <QSideBarLayoutDisplayArea>
              <SettingDiv>
                <Label>{t('Level to display')}</Label>
                <StyledDropdown
                  direction="down"
                  isOpen={isLevelDropdownOpen}
                  toggle={() => openLevelDropdown(!isLevelDropdownOpen)}
                >
                  <StyledDropdownToggle>
                    <StyledToggleButton disableHover bgColor="grayShades.g300">
                      {t(currentLevel.label)}
                      <Icon icon="INTERFACE_CHEVRON_DOWN" size={ImageSize.medium} />
                    </StyledToggleButton>
                  </StyledDropdownToggle>
                  <Menu className="dataByFiltersDropdownMenu">
                    {levelsToDisplay.map(option => {
                      return (
                        <Item
                          disabled={currentLevel.id === option.id}
                          onClick={() => {
                            setCurrentLevel(option);
                          }}
                        >
                          <span>{t(option.label)}</span>
                        </Item>
                      );
                    })}
                  </Menu>
                </StyledDropdown>
              </SettingDiv>
              <SettingDiv>
                <Label>{t('Analysis axis')}</Label>
                <StyledDropdown
                  direction="down"
                  isOpen={isAspectDropdownOpen}
                  toggle={() => openAspectDropdown(!isAspectDropdownOpen)}
                >
                  <StyledDropdownToggle>
                    <StyledToggleButton disableHover bgColor="grayShades.g300">
                      {t(currentAnalysisAxis.label)}
                      <Icon icon="INTERFACE_CHEVRON_DOWN" size={ImageSize.medium} />
                    </StyledToggleButton>
                  </StyledDropdownToggle>
                  <Menu className="dataByFiltersDropdownMenu">
                    {availableAspects.map(option => {
                      return (
                        <Item
                          disabled={currentAnalysisAxis.id === option.id}
                          onClick={() => {
                            setCurrentAnalysisAxis(option);
                          }}
                        >
                          <span>{t(option.label)}</span>
                        </Item>
                      );
                    })}
                  </Menu>
                </StyledDropdown>
              </SettingDiv>
              <SettingDiv>
                <Label>{t('Unit to display')}</Label>
                <StyledDropdown
                  direction="down"
                  isOpen={isUnitDropdownOpen}
                  toggle={() => openUnitDropdown(!isUnitDropdownOpen)}
                >
                  <StyledDropdownToggle>
                    <StyledToggleButton disableHover bgColor="grayShades.g300">
                      {t(currentUnit.label)}
                      <Icon icon="INTERFACE_CHEVRON_DOWN" size={ImageSize.medium} />
                    </StyledToggleButton>
                  </StyledDropdownToggle>
                  <Menu className="dataByFiltersDropdownMenu">
                    {availableUnits.map(option => {
                      return (
                        <Item
                          disabled={currentUnit.id === option.id}
                          onClick={() => {
                            setCurrentUnit(option);
                          }}
                        >
                          <span>{t(option.label)}</span>
                        </Item>
                      );
                    })}
                  </Menu>
                </StyledDropdown>
              </SettingDiv>
              <BenchmarkHorizontalGraphOrderByDropdown
                id="orderByDropdownContainer"
                label="Sort by"
                itemToIterate={ORDER_BY_ITEMS}
                setCurrentOrder={setCurrentOrder}
                defaultOrder={currentOrder}
              />
              <SettingDiv>
                <ThematicSelectionDropdown
                  id="thematicSelectionDropdownContainer"
                  label="button:Selected categories"
                  benchmark
                  t={t}
                  options={[allThematics, ...selectionList]}
                  thematicSelection={horizontalSelectedThematicSelectionOption}
                  setThematicSelection={onThematicSelectionChange}
                />
              </SettingDiv>
            </QSideBarLayoutDisplayArea>
          </QSideBarLayout>
        </Body>
      </StyledCModal>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  benchmarkHorizontalLevelToDisplay: get(state, ['benchmark', 'horizontalLevelToDisplay']),
  benchmarkAspectToDisplay: get(state, ['benchmark', 'aspectToDisplay']),
  benchmarkUnitToDisplay: get(state, ['benchmark', 'unitToDisplay']),
  benchmarkOnlySelectedCategories: get(state, ['benchmark', 'onlySelectedCategories']),
  benchmarkHorizontalCategoriesOrder: get(state, ['benchmark', 'horizontalCategoriesOrder']),
  projectId: get(state, ['projects', 'currentProject', 'id']),
  filterKeys: get(state, ['filters', 'filterKeys']),
  selectionList: get(state, ['thematicSelections', 'list']),
  selectedThematicSelectionOption: get(state, ['thematicSelections', 'selectedThematicSelectionOption']),
  range: get(state, ['filters', 'filterKeys', 'range']),
  dataCollectorId: get(state, ['filters', 'filterKeys', 'dataCollectorId']),
  thematicSelectionId: get(state, ['thematicSelections', 'selectedThematicSelectionOption', 'id']),
  horizontalSelectedThematicSelectionOption: get(state, ['benchmark', 'horizontalSelectedThematicSelectionOption']),
  horizontalSelectedThematicSelectionId: get(state, ['benchmark', 'horizontalSelectedThematicSelectionOption', 'id']),
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchSetHorizontalLevelToDisplay: (newState: any) => {
    dispatch(setHorizontalLevelToDisplay(newState));
  },
  dispatchSetAspectToDisplay: (newState: any) => {
    dispatch(setAspectToDisplay(newState));
  },
  dispatchSetUnitToDisplay: (newState: any) => {
    dispatch(setUnitToDisplay(newState));
  },
  dispatchSetOnlySelectedCategories: (newState: any) => {
    dispatch(setOnlySelectedCategories(newState));
  },
  dispatchSetHorizontalCategoriesOrder: (newState: any) => {
    dispatch(setHorizontalCategoriesOrder(newState));
  },
  dispatchSetHorizontalSelectedThematicSelectionOption: (horizontalSelectedThematicSelectionOption: any) => {
    dispatch(setHorizontalSelectedThematicSelectionOption(horizontalSelectedThematicSelectionOption));
  },
  dispatchSelectThematicSelection: (thematicSelection: any) => {
    dispatch(selectThematicSelection(thematicSelection));
  },
  dispatchSetThematicSelectionList: thematicSelectionList => {
    dispatch(setThematicSelectionList(thematicSelectionList));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation(['button', 'benchmark'])(BenchmarkHorizontalGraphSettingsModal));
